export const ErrorType = {
    EmptyCurrencyException: "emptyCurrencyException"
};
